module.exports = { "default": require("core-js/library/fn/get-iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/react-json-tree/~/babel-runtime/core-js/get-iterator.js
// module id = 663
// module chunks = 0